import React from 'react';
var DigitalEditingMarketingVideo = function DigitalEditingMarketingVideo(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/React.createElement("div", {
    className: "h-100"
  }, /*#__PURE__*/React.createElement("iframe", {
    className: "w-100 border-0",
    src: url,
    title: "Digital Editing Marketing Video",
    allow: "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
    allowFullScreen: true
  }));
};
export default DigitalEditingMarketingVideo;